import { create } from 'zustand';
import type { EmbedSuggestionItem } from './shared/types';

type EmbedSuggestionState = {
  _registry: Record<string, true>;
  embeds: EmbedSuggestionItem[];
  findMatches: (text: string) => EmbedSuggestionItem[];
  addEmbed: (embed: EmbedSuggestionItem[]) => void;
};

export const embedSuggestionState = create<EmbedSuggestionState>(
  (set, get) => ({
    _registry: {},
    embeds: [],
    findMatches: (text) => {
      const { embeds } = get();
      return embeds.filter((embed) =>
        embed.regex.some((regex) => regex.test(text)),
      );
    },
    addEmbed: (embed) => {
      set((state) => {
        embed.forEach((item) => {
          if (state._registry[item.type]) return state;

          state.embeds.push(item);
          state._registry[item.type] = true;
          return state;
        });

        return state;
      });
    },
  }),
);
